import React from "react";

export const truncate = (text: string, maxLength = 50): string => {
  if (text.length > maxLength) {
    const sideLength = Math.floor(maxLength / 2);
    const left = text.substring(0, sideLength);
    const right = text.substring(text.length - sideLength, text.length);
    return `${left} ... ${right}`;
  }
  return text;
};

export interface TruncateTextProps {
  text: string;
  maxLength?: number;
}

const TruncateText: React.FC<TruncateTextProps> = ({ text, maxLength }: TruncateTextProps) => {
  return <span title={text}>{truncate(text, maxLength)}</span>;
};

export default TruncateText;
